import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './droppable-row.scss';

const DroppableRow = ({ children, transaction, onExpenseDrop }) => {
  const [isOver, setIsOver] = useState(false);
  
  const isDroppable = !transaction.checksum;

  const handleDragOver = (e) => {
    if (!isDroppable) return;
    
    e.preventDefault();
    e.stopPropagation();
    if (!isOver) {
      setIsOver(true);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOver(false);
  };

  const handleDrop = (e) => {
    if (!isDroppable) return;
    
    e.preventDefault();
    e.stopPropagation();
    setIsOver(false);
    
    try {
      const expense = JSON.parse(e.dataTransfer.getData('application/json'));
      if (expense?.checksum) {
        onExpenseDrop(expense, transaction);
      }
    } catch (error) {
      console.error('Error parsing dropped expense data:', error);
    }
  };

  return (
    <tr 
      className={`droppable-row ${isOver ? 'drag-over' : ''} ${isDroppable ? 'droppable' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      data-testid="droppable-row"
    >
      {children}
    </tr>
  );
};

DroppableRow.propTypes = {
  children: PropTypes.node.isRequired,
  transaction: PropTypes.object.isRequired,
  onExpenseDrop: PropTypes.func.isRequired
};

export default DroppableRow;
